export const {
  VITE_USER_POOL_ID: userPoolId,
  VITE_CLIENT_ID: clientId,
  VITE_CLIENT_SECRET: clientSecret,
} = import.meta.env || {};

export const THERAPIST_DIRECT_VALIDATION_USER: string =
  "therapist_direct_validation_user";

export const THERAPIST_DIRECT_SESSION: string = "therapist_direct_session";

export const THERAPIST_DIRECT_USER_ACCOUNT: string =
  "therapist_direct_user_account";

export const THERAPIST_DIRECT_REWARDFUL: string = "therapist_direct_rewardful";
